import React, { useState } from "react";
import './index.css';
import RecipeBrowser from "./components/browser/RecipeBrowser";
import RecipeCreatorChat from "./components/creator/RecipeCreatorChat";
import RecipeExecutionView from "./components/RecipeExecutionView";
import { useAuth } from "./auth/AuthContext";
import { GoogleLoginButton } from "./auth/GoogleLoginButton";
import { createExecution } from "./api/actions";

const RecipePage = () => {
    const [view, setView] = useState('browser');
    const [executionId, setExecutionId] = useState(null);
    const [startingExecution, setStartingExecution] = useState(false);
    const { user, logout, isAuthenticated } = useAuth();

    const handleLogout = () => {
        logout();
    };

    const handleStartExecution = async (recipeId) => {
        if (!recipeId || startingExecution) return;
        setStartingExecution(true);
        try {
            const execution = await createExecution(recipeId);
            setExecutionId(execution.id);
            setView('execute');
        } catch (err) {
            console.error('Failed to start recipe execution:', err);
            alert('Failed to start recipe execution');
        } finally {
            setStartingExecution(false);
        }
    };

    return (
        <div style={{ padding: 12 }}>
            {/* Nav bar */}
            <div className="nav-bar">
                <div className="nav-tabs">
                    <button
                        className={`nav-tab ${view === 'browser' ? 'active' : ''}`}
                        onClick={() => setView('browser')}
                    >
                        Browse
                    </button>
                    {executionId && (
                        <button
                            className={`nav-tab ${view === 'execute' ? 'active' : ''}`}
                            onClick={() => setView('execute')}
                        >
                            Execute
                        </button>
                    )}
                    {isAuthenticated && (
                        <button
                            className={`nav-tab ${view === 'creator' ? 'active' : ''}`}
                            onClick={() => setView('creator')}
                        >
                            Create
                        </button>
                    )}
                </div>
                <div className="nav-auth">
                    {isAuthenticated ? (
                        <>
                            {user?.picture_url && (
                                <img
                                    src={user.picture_url}
                                    alt=""
                                    style={{ width: 32, height: 32, borderRadius: '50%' }}
                                    referrerPolicy="no-referrer"
                                />
                            )}
                            <span style={{ fontSize: 14 }}>{user?.name || user?.email}</span>
                            <button
                                onClick={handleLogout}
                                style={{
                                    background: 'none',
                                    border: '1px solid #ccc',
                                    borderRadius: 4,
                                    padding: '6px 12px',
                                    cursor: 'pointer',
                                    fontSize: 13,
                                }}
                            >
                                Sign Out
                            </button>
                        </>
                    ) : (
                        <GoogleLoginButton />
                    )}
                </div>
            </div>

            {view === 'browser' && (
                <RecipeBrowser
                    onStartExecution={handleStartExecution}
                    startingExecution={startingExecution}
                />
            )}
            {view === 'execute' && executionId && (
                <RecipeExecutionView executionId={executionId} />
            )}
            {view === 'creator' && (
                <RecipeCreatorChat onNavigateToBrowser={() => setView('browser')} />
            )}
        </div>
    );
};

export default RecipePage;
